import { atom } from 'recoil'
import { isBefore } from 'date-fns'
import AppConfig from '../config'

export const loadingState = atom({
  key: 'loadingState',
  default: false,
})

export const activeStepState = atom({
  key: 'activeStepState',
  default: 0,
})

export const accessState = atom({
  key: 'accessState',
  default: {},
})

export const formDataState = atom({
  key: 'formDataState',
  default: {},
})

export const toastState = atom({
  key: 'toastState',
  default: {
    open: false,
  },
})

export const isExpiredDate = (date) => {
  return isBefore(date, new Date())
}

export const isGlobalDomain =
  window.location.hostname === AppConfig.GLOBAL_HOSTNAME
